export default {
  psw: "पासवर्ड",
  topFive: "शीर्ष 5",
  confPsw: "पासवर्ड की पुष्टि कीजिए",
  newPsw: "नया पासवर्ड",
  email: "ईमेल",
  emailId: "ईमेल आईडी",
  submit: "प्रस्तुत करें",
  cancel: "रद्द करें",
  dashboard: "डैशबोर्ड",
  faqs: "एफएक्यू /अक्सर पूछे जाने वाले प्रश्न",
  users: "उपयोगकर्ता",
  appUser: "ऐप उपयोगकर्ता",
  app_users: "ऐप उपयोगकर्ता",
  dimitraAdmin: "दिमित्रा एडमिन",
  admin_users: "एडमिन उपयोगकर्ता",
  search: "ढूँढ़े",
  searchBy: "ढूँढ़े {type}",
  autoCondition: "ऑटो कंडीशन",
  firstName: "पहला नाम",
  lastName: "अंतिम नाम",
  mobile: "मोबाइल",
  mobileNumber: "मोबाइल नंबर",
  department: "विभाग",
  role: "भूमिका",
  status: "स्टेटस",
  permission: "अनुमतियाँ",
  activity_log: "गतिविधि लॉग",
  profile_auth: "प्रोफाइल प्रमाणीकरण",
  countryCode: "देश का कोड",
  selectDept: "विभाग का चयन करें",
  selectRole: "भूमिका चुनें",
  edit: "एडिट करें",
  update: "अपडेट",
  delete: "हटाएँ",
  view: "देखे",
  deactivate: "निष्क्रिय करें",
  activate: "सक्रिय करें",
  serverError: "कुछ गलत हो गया। कृपया कुछ देर बाद प्रयास करें।",
  minute: "मिनट",
  perHour: "प्रति घंटा",
  day: "दिन",
  enterDescription: "अपना विवरण यहाँ दर्ज करें",
  enterHere: "यहाँ दर्ज करें",
  enterMobile: "मोबाइल नंबर दर्ज करें",
  phoneRequired: "फ़ोन नंबर ज़रूरी है",
  phoneValid: "फ़ोन नंबर मान्य होना चाहिए ",
  unableToUpdate: "अपडेट करने में असमर्थ.",
  membershipPlans: "सदस्यता योजनाएँ",
  byWeek: "सप्ताह अनुसार",
  byMonth: "महीना अनुसार",
  byYear: "वर्ष के अनुसार",
  custom: "अनुकूलन ",
  name: "नाम",
  regionState: "क्षेत्र/राज्य",
  provinceState: "प्रांत/राज्य",
  cityTown: "शहर/कस्बा",
  membershipValidity: "सदस्यता वैधता",
  exportAsCSV: "CSV के रूप में निर्यात करें",
  filterBy: "इसके द्वारा फ़िल्टर करें",
  comingSoon: "जल्द आ रहा है",
  userRole: "उपयोगकर्ता की भूमिका",
  additionalInformationRequired: "अतिरिक्त आवश्यकता जानकारी",
  approve: "स्वीकृत करें",
  reject: "अस्वीकृत करें ",
  username: "उपयोगकर्ता नाम",
  phone: "फ़ोन",
  roleAssigned: "भूमिका सौंपी गई",
  roleRequested: "भूमिका अनुरोध",
  requestedDate: "अनुरोधित तिथी",
  updateRoleRequest: "भूमिका अनुरोध अपडेट करें",
  message: "संदेश",
  faqSection: {
    createFaq: "अक्सर पूछे जाने वाले प्रश्न बनाएं",
    createTopic: "विषय बनाएँ",
    selectTopic: "विषय का चयन करें",
    faqQuestion: "एफएक्यू प्रश्न",
    faqAnswer: "एफएक्यू उत्तरे",
    uploadImgVid: "तस्वीर/वीडियो अपलोड करें",
    disInFaq: "एफएक्यू प्रश्न अनुभाग में प्रदर्शित करें",
    editFaq: "एफएक्यू संपादित करें",
    topicName: "विषय का नाम ",
    parentTopic: "मूल विषय",
    editTopic: "विषय संपादित करें ",
    createSection: "Please create section first",
    createTopicFirst: "Please create topic first",
    questionReq: "FAQ Question is required",
    answerReq: "FAQ Answer is required",
  },
  reports: {
    male: "पुरुष",
    female: "महिला",
    other: "अन्य",
    farmerName: "किसान का नाम",
    farmerProdChart: "किसान के उत्पादन का चार्ट",
    production: "उत्पादन",
    byProduction: "उत्पादन अनुसार",
    byName: "नाम अनुसार",
    descending: "अवरोही",
    ascending: "आरोही",
    buyingStationProdChart: "खरीदारी केंद्र का उत्पादन चार्ट",
    buyingStation: "खरीदने का केंद्र",
    buyingStationName: "खरीदारी केंद्र का नाम ",
    dryMilling: "सूखी मिलिंग",
    dryMillingName: "सुखी मिलिंग का नाम",
    dryMillingProdChart: "सुखी मिलिंग का उत्पादन चार्ट",
    view: "देखें",
    date: "तिथि",
  },
  traceability: {
    traceability: "ट्रेसेबिलिटी",
    coffeeTraceabilityMngmnt: "कॉफ़ी ट्रेसेबिलिटी प्रबंधन",
    traceabilityPage: "ट्रेसेबिलिटी पेज",
    labelDesigner: "लेबल डिजाइनर",
    additionalInformation: "अतिरिक्त जानकारी",
    info1:
      "अपने उत्पाद के अतिरिक्त लोगों के बारे में जानकारी प्रदान करें। यह जानकारी कॉफ़ी ट्रेसेबिलिटी पेज पर सार्वजनिक होगी।",
    addSlogan: "स्लोगन जोड़ें",
    additionalLogos: "अतिरिक्त लोगों",
    title: "शीर्षक",
    description: "विवरण",
    mapLink: "नक्शा लिंक",
    websiteLink: "वेबसाइट लिंक",
    addMedia: "मीडिया जोड़ें",
    uploadImageVideo: "छवि/वीडियो अपलोड करें",
    origin: "उत्पत्ति",
    info2:
      "अपने उत्पाद की उत्पत्ति देश के बारे में जानकारी प्रदान करें। यह जानकारी कॉफ़ी ट्रेसेबिलिटी पेज पर सार्वजनिक होगी।",
    countryImage: "देश छवि",
    institutionalInfo: "संस्थागत जानकारी",
    info3:
      "अपनी कंपनी/सहकारी के बारे में जानकारी प्रदान करें, उपभोक्ताओं को आपके द्वारा किया गया संबंधित कार्य के बारे में बताएं। यह जानकारी कॉफ़ी ट्रेसेबिलिटी पेज पर सार्वजनिक होगी।",
    cooperativeLogo: "सहकारी लोगो",
    traceabilityIntro: "ट्रेसेबिलिटी परिचय",
    info4:
      "यह खंड उपभोक्ता को कॉफ़ी के पूरे उत्पादन और प्रसंस्करण इतिहास तक पहुंच देगा। अपनी कंपनी/सहकारी के लिए ट्रेसेबिलिटी के महत्त्व का वर्णन करें।",
    addLabel: "लेबल जोड़ें",
    chooseTitle: "शीर्षक चुनें",
    chooseLabelDesign: "लेबल डिजाइन टेम्प्लेट चुनें",
    uploadYourLogo: "अपना लोगो अपलोड करें",
    info5:
      "निर्देश: छवि का आकार कम से कम 1000 x 1000 पिक्सेल वर्ग होना चाहिए। आप पारदर्शी PNG का चयन कर सकते हैं ताकि बैकग्राउंड रंगों के साथ समंगत हो।",
    chooseTemplateColors: "टेम्प्लेट रंग चुनें",
    backgroundColor: "पृष्ठभूमि रंग",
    foregroundColor: "पूर्वभूमि रंग",
    labelStatus: "लेबल स्थिति",
    inactive: "निष्क्रिय",
    download: "डाउनलोड करें",
    enterLabelTitle: "लेबल शीर्षक दर्ज करें",
  },
  cacaoTraceability: {
    traceability: "ट्रेसेबिलिटी",
    cacaoTraceabilityMngmnt: "कैको ट्रेसेबिलिटी प्रबंधन",
    traceabilityPage: "ट्रेसेबिलिटी पेज",
    labelDesigner: "लेबल डिजाइनर",
    additionalInformation: "अतिरिक्त जानकारी",
    info1:
      "अपने उत्पाद के अतिरिक्त लोगों के बारे में जानकारी प्रदान करें। यह जानकारी कैको ट्रेसेबिलिटी पेज पर सार्वजनिक होगी।",
    addSlogan: "स्लोगन जोड़ें",
    additionalLogos: "अतिरिक्त लोगों",
    title: "शीर्षक",
    description: "विवरण",
    mapLink: "नक्शा लिंक",
    websiteLink: "वेबसाइट लिंक",
    addMedia: "मीडिया जोड़ें",
    uploadImageVideo: "छवि/वीडियो अपलोड करें",
    origin: "उत्पत्ति",
    info2:
      "अपने उत्पाद की उत्पत्ति देश के बारे में जानकारी प्रदान करें। यह जानकारी कैको ट्रेसेबिलिटी पेज पर सार्वजनिक होगी।",
    countryImage: "देश छवि",
    institutionalInfo: "संस्थागत जानकारी",
    info3:
      "अपनी कंपनी/सहकारी के बारे में जानकारी प्रदान करें, उपभोक्ताओं को आपके द्वारा किया गया संबंधित काम के बारे में बताएं। यह जानकारी कैको ट्रेसेबिलिटी पेज पर सार्वजनिक होगी।",
    cooperativeLogo: "सहकारी लोगो",
    traceabilityIntro: "ट्रेसेबिलिटी परिचय",
    info4:
      "यह खंड उपभोक्ता को कैको के पूरे उत्पादन और प्रसंस्करण इतिहास तक पहुंच देगा। अपनी कंपनी/सहकारी के लिए ट्रेसेबिलिटी के महत्त्व का वर्णन करें।",
    addLabel: "लेबल जोड़ें",
    chooseTitle: "शीर्षक चुनें",
    chooseLabelDesign: "लेबल डिजाइन टेम्प्लेट चुनें",
    uploadYourLogo: "अपना लोगो अपलोड करें",
    info5:
      "निर्देश: छवि का आकार कम से कम 1000 x 1000 पिक्सेल वर्ग होना चाहिए। आप पारदर्शी PNG का चयन कर सकते हैं ताकि बैकग्राउंड रंगों के साथ समंगत हो।",
    chooseTemplateColors: "टेम्प्लेट रंग चुनें",
    backgroundColor: "पृष्ठभूमि रंग",
    foregroundColor: "पूर्वभूमि रंग",
    labelStatus: "लेबल स्थिति",
    inactive: "निष्क्रिय",
    download: "डाउनलोड करें",
    enterLabelTitle: "लेबल शीर्षक दर्ज करें",
  },
  setting: {
    profileAuthSetting: "प्रोफ़ाइल प्रमाणीकरण सेटिंगस",
    logInOutSetting: "लॉग इन/लॉगऑफ़ सेटिंग्स",
    autoLogout: "अपने आप लॉग-ऑफ",
    unsuccessfulLoginAttempt: "लॉगिन का प्रयास असफल रहा ",
    unsuccessfulLoginLockPeriod: "असफल लॉगिन लॉक-आउट अवधि",
    passCriteriaSetup: "पासवर्ड मानदंड की रचना",
    passLength: "पासवर्ड की लंबाई",
    noUniquePassRequired: "आवश्यक अद्वितीय पासवर्ड की संख्या",
    maxPassAge: "पासवर्ड की अधिकतम उम्र",
    acceptableRangeOfChars: "वर्णों की स्वीकार्य श्रेणी",
    upperCase: "अप्पर केस",
    lowerCase: "लोअर केस ",
    numbers: "संख्या",
    specialChars: "विशेष वर्ण",
    uniqueSymbols: "अद्वितीय प्रतीक",
    loadingData: "डेटा लोड हो रहा है",
    currency: "मुद्रा",
    codeActivationTime: "कोड को सक्रिय करने का समय",
    changeGlobalSetting: "कोड को सक्रिय करने का समय",
    globalSetting: "समग्र सेटिंग्स",
    generalSetting: "सामान्य सेटिंग्स",
    hour: "घंटे",
    days: "दिन",
    minutes: "मिनट",
    perDay: "प्रति दिन",
    perHour: "प्रति घंटा",
    customised: "अनुकूलित",

    smallFarm: "छोटा खेत",
    inclusive: "समावेशी",
    from: "से",
    to: "तक",
    mediumFarm: "मध्यम खेत",
    largeFarm: "बड़ा खेत",
    requiredMessage: "यह फ़ील्ड आवश्यक है",
    nonNegativeMessage: "यह फ़ील्ड गैर-नकारात्मक होनी चाहिए",
    fieldToGreaterThanFrom: "यह फ़ील्ड 'से' फ़ील्ड से बड़ा होना चाहिए",
    fieldToGreaterThanFromMedium: "यह फ़ील्ड छोटे खेत के 'तक' फ़ील्ड से बड़ा होना चाहिए",
    fieldToGreaterThanMediumTo: "यह फ़ील्ड मध्यम खेत के 'तक' फ़ील्ड से बड़ा होना चाहिए",
  },
  coffeeData: {
    windBreaker: "हवा रोधक वृक्ष",
    horticultureInfo: "बागवानी वृक्ष",
    shadeTree: "छाया वृक्ष",
    coffeeVariety: "कॉफी की किस्में",
    coffeeSpecies: "कॉफी की प्रजाति",
    updateWindBreaker: "हवा रोधक वृक्षों के प्रकार को अपडेट करें",
    addWindBreaker: "एक नया मौसम प्रतिरोधी वृक्ष का प्रकार दर्ज करें",
    updateHorticultureInfo: "बागवानी वृक्षों के प्रकार को अपडेट करें",
    addHorticultureInfo: "बागवानी वृक्षों की नई प्रजाति दर्ज करें",
    updateShadeTree: "छायादार वृक्षों के  प्रकार को अपडेट करें",
    addShadeTree: "कॉफी की किस्म का प्रकार दर्ज करें",
    updateCoffeeVariety: "कॉफी की किस्म का प्रकार अपडेट करें",
    addCoffeeVariety: "कॉफी की किस्म का प्रकार दर्ज करें",
    deleteVarietyTitle: "किस्मों को हटाएँ ",
    deleteVarietyMessage: "क्या आप वाकई इस प्रजाति को हटाना चाहते हैं?",
    updateCoffeeSpecie: "कॉफी की प्रजाति अपडेट करें",
    deleteSpecieTitle: "प्रजाति हटाएँ",
    deleteSpecieMessage: "क्या आप वाकई इस प्रजाति को हटाना चाहते हैं?",
    addCoffeeSpecie: "कॉफ़ी की नई प्रजाति दर्ज करें",
    variety: "किस्में ",
    selectVariety: "किस्म का चयन करें",
    deleteCoffeeRecord: "क्या आप वाकई रिकॉर्ड हटाना चाहते हैं?",
    deleteCoffeeData: "कॉफी डेटा हटाएँ",
    topicRequired: "विषय का नाम आवश्यक है",
    coffeeAddSuccess: "कॉफी की प्रजाति सफलतापूर्वक जोड़ी गई।",
    treeTypeSuccess: "पेड़ का प्रकार सफलतापूर्वक दर्ज किया गया।",
    treeTypeUpdateSuccess: "पेड़ का प्रकार सफलतापूर्वक अपडेट किया गया।",
    coffeeVarietySuccess: "कॉफी की किस्म सफलतापूर्वक जोड़ी गई।",
    coffeeSpecieSuccess: "कॉफ़ी की प्रजाति सफलतापूर्वक अपडेट की गई ",
    nameRequired: "नाम आवश्यक है",
    notFound: "एडमिन का कोई कॉफ़ी डेटा नहीं मिला",
  },
  cacaoData: {
    cacao: "कैको",
    cacaoVariety: "कैको प्रकार",
    cacaoSpecies: "कैको प्रजाति",
    deleteCacaoData: "कैको डेटा हटाएं",
  },
  plantation: {
    farmerName: "किसान का नाम",
    phoneNumber: "फ़ोन नंबर",
    plantationName: "वृक्षारोपण का नाम",
    farm: "खेत",
    location: "स्थान",
    updatePlantationStatus: "वृक्षारोपण की स्थिति अपडेट करें",
    update: "अपडेट करें",
  },
  dashboardReports: {
    appDataReports: "ऐप डेटा रिपोर्ट्स",
    reports: "रिपोर्ट्स",
  },
  activationKey: {
    enterActivationKey: "Please enter activation key to register a new user",
    activationKeyLimit: "Minimum 15 characters",
    countryRequired: "Country Code is required",
    activationKey: "एक्टिवेशन कीज",
    appointSalesManager: "बिक्री प्रबंधक नियुक्त करें",
    appointManager: "नियुक्ति प्रबंधक",
    salesManAppSuccess: "बिक्री प्रबंधक सफलतापूर्वक नियुक्त किया गया",
    uploadData: "सौंपा गया डेटा CSV के रूप में अपलोड करें",
    uploadUserData: "कृपया उपयोगकर्ता डेटा फ़ाइल अपलोड करें।",
    downloadCsv:
      "(संरचना का पालन करने के लिए .csv फ़ाइल का सैंपल डाउनलोड करें)",
    downloadSample: "सैंपल फाइल डाउनलोड करें",
    dragDrop: "अपनी फ़ाइल को खींचें और छोड़ें या फिर ब्राउज़ करें।",
    browse: "ब्राउज़",
    yourFile: "आपकी फाइल",
    incorectFileType: "गलत प्रकार की फाइल",
    somethingWentWrong: "कुछ गलत हो गया",
    fileUploadedSuccess: "फाइल सफलतापूर्वक अपलोड की गई",
    countRecords: "रिकॉर्ड गिनें",
    sendNow: "अभी भेजें",
    fileName: "फाइल का नाम",
    assignActKey: "एक्टिवेशन कीज सौंपी जा रही हैं",
    actKeyAssSucc: "एक्टिवेशन कीज सफलतापूर्वक सौंप दी गईं ",
    viewActKey: "एक्टिवेशन कीज देखें",
    actKeyQuota: "एक्टिवेशन कीज कोटा",
    genActKey: "जेनरेटेड एक्टिवेशन कीज",
    remActKey: "शेष एक्टिवेशन कीज",
    penUsed: "लंबित और प्रयुक्त कीज",
    activationKeyAss: "नियुक्त की गई एक्टिवेशन कीज",
    activationKeyUnass: "नियुक्त न की गई एक्टिवेशन कीज ",
    keysAct: "सक्रिय कीज",
    uploadedFiles: "अपलोड की गई फ़ाइलें",
    generateActKey: "एक्टिवेशन कीज उत्पन्न करें",
    showData: "डेटा दिखाएँ ",
    noDataFound: "कोई तिथि नहीं मिली",
    pleaseGenKey:
      'कृपया "एक्टिवेशन कीज उत्पन्न करें" का उपयोग करके एक्टिवेशन कीज बनाएँ',
    noActKey: "अभी तक कोई एक्टिवेशन कीज उत्पन्न नहीं हुई हैं",
    buttonAbv: "ऊपर का बटन",
    numberOfActKey: "एक्टिवेशन कीज की संख्या",
    membershipRole: "सदस्यता भूमिका",
    membershipPlan: "सदस्यता योजनाएँ",
    comments: "टिप्पणियाँ",
    genKeys: "कीज उत्पन्न करें",
    keysNum: "कीज की संख्या",
    phoneNumber: "फ़ोन नंबर",
    keysStatus: "कीज की स्तिथि",
    ActivationKeysList: "एक्टिवेशन कीज की सूचि",
    back: "पीछे",
    usingActKeys: "एक्टिवेशन कीज उत्पन्न करें के उपयोग से",
    pleaseGenActKeyss: "कृपया एक्टिवेशन कीज उत्पन्न करें",
    clearAllFilters: "सभी फिल्टर साफ करें",
    salesManager: "बिक्री प्रबंधक",
    clearAll: "सभी साफ करें",
    generatedBy: "इसके द्वारा उत्पन किया गया",
    numberOfKeys: "कीज की संख्या",
    action: "कार्यवाही",
    viewAllUplFiles: "अपलोड की गई सभी फाइलें देखें",
    bulkUploadUsers: "थोक अपलोड उपयोगकर्ता",
    noActivationKeyFound: "कोई एक्टिवेशन कीज नहीं मिलीं",
    pleaseCreateAdminRole: "कृपया ऊपर 'एडमिन भूमिका बनाएँ' बटन",
    btnCreateAdmin: "का उपयोग करके एडमिन भूमिका बनाएँ",
    donwloadAsCsv: "CSV के रूप में डाउनलोड करें",
    donwloadAsPdf: "PDF के रूप में डाउनलोड करें",
    assignSalesManager: "बिक्री प्रबंधक असाइन करें",
    shareViaEmail: "ईमेल के माध्यम से साझा करें",
    sendEmail: "ईमेल भेजें",
    emailSend: "ईमेल सफलतापूर्वक भेजी गई",
    donwload: "डाउनलोड",
    deleteFile: "फाइल हटाएँ",
    invalidFileData: "फ़ाइल पर सक्रियण कुंजी डेटा अमान्य है",
    continue: "आगे बढ़ें",
    description: "विवरण",
    selectWeek: "सप्ताह चुनें ",
    confirm: "पुष्टि करें",
    selectMonth: "महीना चुनें",
    selectDateRange: "तिथि सीमा चुनें",
    regionDistrict: "क्षेत्र/जिला",
    address: "पता",
    familyTribe: "परिवार जनजाति",
    website: "वेबसाइट",
    deactivated: "निष्क्रिय",
    active: "सक्रिय",
    country: "देश",
    farmer: "किसान",
    commodity: "वस्तु",
    quantity: "मात्रा",
    unit: "इकाई",
    price: "कीमत",
    save: "सहेजें",
    stateIsReq: "राज्य आवश्यक है",
    cityIsReq: "शहर आवश्यक है",
    addressIsReq: "Address is required",
    membershipTypeReq: "Membership type is required",
    extendedReasonReq: "Extend reason is required",
    numberOfDaysReq: "Number of days is required",
    extendedMembershipValidity: "विस्तारित सदस्यता वैधता",
    set: "SET",
    adminRole: "एडमिन भूमिकाएँ",
    typeMsg: "Type your message here",
    errors: {
      cannotBeBlank: "यह क्षेत्र खाली नहीं रह सकता",
      required: "यह क्षेत्र अनिवार्य है ",
      somethingWentWrong: "कुछ गलत हो गया। कृपया कुछ देर बाद प्रयास करें।",
    },
    loadingData: "डेटा लोड हो रहा है",
    markAsRead: "पढ़ा हुआ चिन्हित करें ",
    membership: {
      remainingDays: "बचे हुए दिनों की संख्या",
      type: "सदस्यता का प्रकार",
      validity: "सदस्यता की वैधता",
      validityLength: {
        custom: "अनुकूलन",
        expired: "खत्म हो चुका",
        oneTo8Months: "1-8 महीने",
        lessThan1Month: "1 महीने से कम ",
        moreThan1Month: "1 वर्ष से ज़्यादा ",
        sixTo12Months: "6-12 महीने ",
      },
    },
    of: "का",
    ok: "ठीक है",
    statusItems: {
      closed: "बंद",
      open: "खुला",
    },
    orderByItems: {
      all: "सभी",
      dateAscending: "आरोही क्रम में तिथि",
      dateDescending: "अवरोही क्रम में तिथि",
      dueDate: "नियत तारीख",
      high: "उच्च",
      low: "कम",
      medium: "मध्यम",
    },
    orderBy: "इस तरह से ऑर्डर ",
    select: "चुनें",
    type: "प्रकार",
    uploadImageVideo: "तस्वीरें/विडियोज अपलोड करें ",
    user: "उपभोग्कर्ता ",
    userName: "उपयोगकर्ता नाम",
    usersSelected: "उपयोगकर्ता चुना गया ",
    topics: "विषय",
    date: "तिथि",
    addNew: "एक नया दर्ज करें",
    exportAsCsv: "CSV के रूप में निर्यात करें",
    noData: "कोई डेटा नहीं मिला",
    login: {
      welcomeMsg: "स्वागत! लॉग इन करें",
      info: "अपनी साख दर्ज करें।",
      forgot: "पासवर्ड भूल गए?",
      btn: "लॉग इन",
      unableToLogin: "लॉगिन करने में असमर्थ",
    },
    forgot: {
      info_l1:
        "कृपया अपने खाते से संबद्ध ईमेल पता दर्ज करें। पासवर्ड विवरण आपके ईमेल पते पर भेज दिए जाएंगे।",
      info_l2:
        "अपने खाते से जुड़ा अपना मोबाइल नंबर कृपया दर्ज करें। पासवर्ड की जानकारी फोन नंबर पर भेजी जाएगी।",
      forgotQ: "पासवर्ड भूल गए हैं?",
      loginNow: "अभी लॉगिन करें",
      resetSucc: "आपका पासवर्ड सफलतापूर्वक रीसेट हो गया",
      resetSucc_l2:
        "अब आप अपने खाते में लॉगिन करने के लिए अपने नए पासवर्ड का उपयोग कर सकते हैं।",
      entPsw: "कृपया अपना नया पासवर्ड दर्ज करें।",
      resetPsw: "अपना पासवर्ड रीसेट करें",
      resendOTP: "ओटीपी दुबारा भेजें ",
      enterCorrectOTP: "कृपया सही ओटीपी दर्ज करें।",
      enterOTP: "कृपया ईमेल/मोबाइल पर प्राप्त ओटीपी दर्ज करें",
    },
    userslist: {
      createNewUser: "Create a New User",
      chooseCreateType: "Please choose one of the following options:",
      addNewUser: "नया उपयोगकर्ता को जोड़ें",
      editUser: "उपयोगकर्ता एडिट करें",
      addNewAdmin: "नया एडमिन उपयोगकर्ता",
      userLoading: "उपयोगकर्ता लोड हो रहे हैं... कृपया प्रतीक्षा करें",
      noUser: "कोई उपयोगकर्ता उपलब्ध नहीं है",
      extendVal: "वैधता बढ़ाएँ",
      extendReason: "विस्तार का कारण",
      extendReasonMsg: "सदस्यता बढ़ाने का कारण निर्दिष्ट करें",
    },
    addEdituser: {
      firstNameRequired: "पहला नाम आवश्यक है",
      firstNameOllyAlpha: "पहले नाम में केवल अक्षर हो सकते हैं",
      firstNameLimit: "पहला नाम 15 वर्णों से कम होना चाहिए",
      lastNameRequired: "अंतिम नाम आवश्यक है",
      lastNameOllyAlpha: "अंतिम नाम में केवल अक्षर हो सकते हैं",
      lastNameLimit: "अंतिम नाम 15 वर्णों से कम होना चाहिए",
      emailReuired: "ईमेल आवश्यक है",
      emailInvalid: "अमान्य ईमेल फॉर्मेट.",
      mobileRequired: "मोबाइल नंबर आवश्यक है",
      invalidMobile: "अमान्य मोबाइल नंबर फ़ॉर्मेट",
      pswRequired: "पासवर्ड आवश्यक है",
      deptRequired: "विभाग आवश्यक है",
      roleRequired: "भूमिका आवश्यक है",
      countryRequired: "देश का कोड आवश्यक है",
      userUpdated: "उपयोगकर्ता अपडेट किया गया",
      userNotUpdated: "उपयोगकर्ता अपडेट नहीं किया गया",
      activateAct: "खाते को सक्रिय करें",
      deactivateAct: "खाता निष्क्रिय करें",
      userActivated: "उपयोगकर्ता सक्रिय किया गया",
      userDeactivated: "उपयोगकर्ता निष्क्रिय किया गया ",
      deactivateUser: "उपयोगकर्ता को निष्क्रिय करें",
      deactivateMsg: "क्या आप वाकई उपयोगकर्ता का स्टेटस बदलना चाहते हैं?",
      userAdded: "उपयोगकर्ता जोड़ा गया",
      userNotAdded: "उपयोगकर्ता नहीं जोड़ा गया",
      validityUpTo: "Validity Up To",
      facilityPicture: "Facility Picture",
      editAppUser: "ऐप उपयोगकर्ता संपादित करें",
    },
    permissions: {
      savePermissions: "अनुमतियाँ सेव करें",
      moduleName: "मोड्यूल का नाम",
      view: "देखें",
      create: "निर्माण",
      update: "अपडेट",
      delete: "हटाएँ",
      permissionsUpdated: "अनुमतियाँ अपडेट की गई",
      permissionsNotUpdated: "अनुमतियाँ अपडेट नहीं हुई हैं",
      selectMembership: "सदस्यता चुनें",
      noPermMsg:
        "अपनी अनुमतियाँ देखने के लिए कृपया ऊपर दिए गए 'सदस्यता प्रकार' ड्रॉप डाउन का उपयोग करके सदस्यता प्रकार का चयन करें",
      selectRoleMsg: "अनुमतियाँ दिखाने के लिए कृपया ऊपर एक भूमिका चुनें।",
    },
    logs: {
      time: "समय",
      username: "उपयोगकर्ता का नाम",
      role: "भूमिका",
      terminalID: "टर्मिनल आईडी",
      moduleAccessed: "प्रवेश किया गया मॉड्यूल",
      typeOfAccess: "प्रवेश करने के प्रकार",
      activityLogDetails: "गतिविधियों का लॉग विवरण",
      userId: "उपयोगकर्ता आईडी ",
      lastLogin: "आखरी लॉगइन",
      geoAccPoint: "भौगोलिक एक्सेस पॉइंट ",
      ipAdd: "आई पी एड्रेस",
      filesAccessed: "एक्सेस की गई फाइलें ",
      funAccessed: "एक्सेस किए गए फंक्शन",
      webUrl: "वेब पेज युआरएल ",
      unsuccAtmp: "असफल लॉगइन प्रयास ",
      view: "देखें",
      membershipType: "सदस्यता का प्रकार",
    },
    profileSetting: {
      profileAuthSettings: "प्रोफ़ाइल प्रमाणीकरण सेटिंगस",
      changeSettings: "सेटिंग बदलें",
      loginLogoutSettings: "लॉग इन/लॉगऑफ़ सेटिंग्स",
      autoLogout: "अपने आप लॉग-ऑफ",
      unsuccAtmp: "लॉगिन का प्रयास असफल रहा",
      unsuccLoginLock: "असफल लॉगिन लॉक-आउट अवधि",
      pswCrisetup: "पासवर्ड मानदंड की रचना ",
      pswLength: "पासवर्ड की लंबाई",
      noOfUniquePsw: "आवश्यक अद्वितीय पासवर्ड की संख्या",
      maxPswAge: "पासवर्ड की अधिकतम उम्र",
      AccRangeOfchars: "वर्णों की स्वीकार्य श्रेणी",
      upperCase: "अप्पर केस",
      lowerCase: "लोअर केस",
      numbers: "संख्या",
      specialChars: "विशेष वर्ण ",
      settingsUpdated: "सेटिंग्स अपडेट की गई ",
      settingsNotUpdated: "सेटिंग्स अपडेट नहीं हुई ",
    },
    dashboardSection: {
      modules: "मॉड्यूल्स",
      allowances: "भत्ते",
      maxUserAllowed: "अधिकतम अनुमत उपयोगकर्ता",
      satelliteReportsAllowed: "अनुमत उपग्रह रिपोर्टें",
      advanceReport: "अनुमत उन्नत रिपोर्टें",
      subscriptionUpTo: "निम्नलिखित तिथि तक सदस्यता",
      roleAllowed: "अनुमत भूमिकाएँ",
      moduleAllowed: "अनुमत मॉड्यूल्स",
      registeredUsers: "पंजीकृत उपयोगकर्ता",
      validMemberships: "वैध सदस्यता",
      activeUsers: "सक्रिय उपयोगकर्ता",
      deactivatedUsers: "निष्क्रिय उपयोगकर्ता",
      membershipValidity: "सदस्यता वैधता",
      lessThan1Month: "1 महीने से कम",
      months1to6: "1-6 महीने",
      months6to12: "6-12 महीने",
      moreThan1Year: "1 वर्ष से ज़्यादा",
      cropOverview: "फसल अवलोकन",
      plantations: "पौधे",
      coffeeData: "कॉफ़ी डेटा",
      availableModules: "उपलब्ध मॉड्यूल",
      roleList: "किसान, खरीदारी केंद्र, गोदाम",
      memberData: "सदस्य डेटा",
      userType: "उपयोगकर्ता प्रकार",
      registered: "पंजीकृत",
      offlineUsers: "ऑफलाइन उपयोगकर्ता",
      lessThanOneMonth: "< 1 महीना",
      cacaoData: "कैको डेटा",
      dryCacao: "सूखा कैको",
      traceability: "ट्रेसेबिलिटी",
    },
    adminRoles: {
      adminRoles: "एडमिन भूमिकाएँ",
      roleName: "भूमिका का नाम",
      description: "विवरण",
      viewPermissions: "अनुमतियाँ देखें",
      createAdminRole: "एडमिन भूमिका बनाएँ",
      enterDesHere: "अपना विवरण यहाँ दर्ज करें",
      deleteRole: "भूमिका हटाएँ",
      deleteMsg: "क्या आप वाकई भूमिका को हटाना चाहते हैं?",
      roleReq: "भूमिका नाम आवश्यक है",
      roleLimit: "भूमिका का नाम 15 वर्णों से कम होना चाहिए",
      desReq: "विवरण आवश्यक है",
      desLimit: "विवरण 40 वर्ण या उससे कम का होना चाहिए",
      roleSuccess: "भूमिका सफलतापूर्वक बनाई गई",
      editAdminRole: "एडमिन भूमिका संपादित करें",
      roleUpdated: "भूमिका अपडेट की गई ",
      noRole: "कोई व्यवस्थापक भूमिका नहीं मिली",
      noRoleMsg:
        "कृपया ऊपर दिए गए 'एडमिन भूमिका बनाएँ' बटन का उपयोग करके एडमिन भूमिका बनाएँ",
    },
    membershipplanSection: {
      defaultPlan: " डिफ़ॉल्ट योजना बदलें",
      planType: "योजना का प्रकार",
      planDuration: "योजना अवधि",
      planFee: "योजना शुल्क",
      satelliteReport: "उपग्रह रिपोर्टें",
      advanceReport: "उन्नत रिपोर्टें",
      addMembership: "सदस्यता जोड़ें",
      addMembershipPlan: "सदस्यता योजना जोड़ें ",
      accessSetelite: "उपग्रह रिपोर्टों तक पहुँच (5 रिपोर्टों का सेट)",
      accessAdvanceReport: "उन्नत रिपोर्टों तक पहुँच",
      memPlanReq: "सदस्यता योजना की आवश्यकता है",
      memPlanReqLimit: "सदस्यता योजना 20 वर्णों से कम होनी चाहिए",
      SatelliteReq: "उपग्रह रिपोर्ट की आवश्यकता है",
      advancedReportReq: "उन्नत रिपोर्ट की आवश्यकता है",
      durationReq: "सदस्यता अवधि आवश्यक है",
      feeReq: "सदस्यता शुल्क आवश्यक है",
      cantLesThenZero: "0 से कम नहीं होना चाहिए",
      roleReq: "उपयोगकर्ता भूमिका की आवश्यकता है",
    },
    tickets: {
      actions: {
        create: "टिकट बनाएँ ",
        delete: "टिकट हटाएँ",
        edit: "टिकट संपादित करें",
      },
      areaOfRequest: "अनुरोध का क्षेत्र",
      assignee: "प्रतिनिधि",
      deleteTicket: {
        confirmation: "क्या आप वाकई {0} टिकट को हटाना चाहते हैं?",
      },
      dueDate: "नियत तारीख",
      filters: {
        ticketFor: "के लिए टिकट",
      },
      form: {
        ticketType: {
          admin: "दिमित्रा एडमिन के लिए टिकट बनाएँ ",
          user: "ऐप उपयोगकर्ता के लिए टिकट बनाएँ ",
        },
      },
      markAsRead: "पढ़ा हुआ चिन्हित करें ",
      messages: {
        created: {
          success: "टिकट सफलतापूर्वक बनाई गई।",
        },
        deleted: {
          success: "टिकट सफलतापूर्वक हटाई गई।",
        },
      },
      noData: "कोई टिकेटें नहीं मिलीं!",
      noDataHelpText: `आपको कोई टिकट (0) नहीं दी गई है। आरंभ करने के लिए इस स्क्रीन के ऊपर दिए गए "टिकट बनाएँ" बटन{1}पर क्लिक करें।`,
      pickerInMenu: "मेनू में चयनकर्ता",
      priority: {
        high: "उच्च",
        label: "प्राथमिकता",
      },
      reply: "जवाब दें",
      requestedDateTime: "अनुरोधित तिथि और समय",
      requestorDetails: "अनुरोधकर्ता का विवरण",
      requestorEmail: "अनुरोधकर्ता का ईमेल",
      subject: "विषय",
      ticketsForItems: {
        all: "सभी",
        dimitraAdmin: "दिमित्रा एडमिन",
        multipleUsers: "अनेक उपयोगकर्ता",
        singleUser: "एकल उपयोगकर्ता",
      },
      title: "टिकट",
    },
    roleRequest: {
      roleRequest: "भूमिका अनुरोध",
      userRole: "उपयोगकर्ता की भूमिका",
      approve: "स्वीकृत करें",
      reject: "अस्वीकृत करें ",
      username: "उपयोगकर्ता नाम",
      email: "ईमेल",
      phone: "फ़ोन",
      roleAssigned: "भूमिका सौंपी गई",
      roleRequested: "भूमिका अनुरोध",
      requestedDate: "अनुरोधित तिथी",
      updateRoleRequest: "भूमिका अनुरोध अपडेट करें",
      message: "संदेश",
      update: "अपडेट करें",
    },
    faqSection: {
      createFaq: "अक्सर पूछे जाने वाले प्रश्न बनाएं",
      createTopic: "विषय बनाएँ",
      selectTopic: "विषय का चयन करें",
      faqQuestion: "एफएक्यू प्रश्न",
      faqAnswer: "एफएक्यू उत्तरे",
      uploadImgVid: "तस्वीर/वीडियो अपलोड करें",
      disInFaq: "एफएक्यू प्रश्न अनुभाग में प्रदर्शित करें",
      editFaq: "एफएक्यू संपादित करें",
      topicName: "विषय का नाम ",
      parentTopic: "मूल विषय",
      editTopic: "विषय संपादित करें ",
      createSection: "Please create section first",
      createTopicFirst: "Please create topic first",
      questionReq: "FAQ Question is required",
      answerReq: "FAQ Answer is required",
    },
    reports: {
      farmerName: "किसान का नाम",
      farmerProdChart: "किसान के उत्पादन का चार्ट",
      production: "उत्पादन",
      byProduction: "उत्पादन अनुसार",
      byName: "नाम अनुसार",
      descending: "अवरोही",
      ascending: "आरोही",
      buyingStationProdChart: "खरीदारी केंद्र का उत्पादन चार्ट",
      buyingStation: "खरीदने का केंद्र",
      buyingStationName: "खरीदारी केंद्र का नाम ",
      dryMilling: "सूखी मिलिंग",
      dryMillingName: "सुखी मिलिंग का नाम",
      dryMillingProdChart: "सुखी मिलिंग का उत्पादन चार्ट",
      view: "देखें",
      date: "तिथि",
    },
    traceability: {
      traceability: "ट्रेसेबिलिटी",
      coffeeTraceabilityMngmnt: "कॉफ़ी ट्रेसेबिलिटी प्रबंधन",
      traceabilityPage: "ट्रेसेबिलिटी पेज",
      labelDesigner: "लेबल डिजाइनर",
      additionalInformation: "अतिरिक्त जानकारी",
      info1:
        "अपने उत्पाद के अतिरिक्त लोगों के बारे में जानकारी प्रदान करें। यह जानकारी कॉफ़ी ट्रेसेबिलिटी पेज पर सार्वजनिक होगी।",
      addSlogan: "स्लोगन जोड़ें",
      additionalLogos: "अतिरिक्त लोगों",
      title: "शीर्षक",
      description: "विवरण",
      mapLink: "नक्शा लिंक",
      websiteLink: "वेबसाइट लिंक",
      addMedia: "मीडिया जोड़ें",
      uploadImageVideo: "छवि/वीडियो अपलोड करें",
      origin: "उत्पत्ति",
      info2:
        "अपने उत्पाद की उत्पत्ति देश के बारे में जानकारी प्रदान करें। यह जानकारी कॉफ़ी ट्रेसेबिलिटी पेज पर सार्वजनिक होगी।",
      countryImage: "देश छवि",
      institutionalInfo: "संस्थागत जानकारी",
      info3:
        "अपनी कंपनी/सहकारी के बारे में जानकारी प्रदान करें, उपभोक्ताओं को आपके द्वारा किया गया संबंधित कार्य के बारे में बताएं। यह जानकारी कॉफ़ी ट्रेसेबिलिटी पेज पर सार्वजनिक होगी।",
      cooperativeLogo: "सहकारी लोगो",
      traceabilityIntro: "ट्रेसेबिलिटी परिचय",
      info4:
        "यह खंड उपभोक्ता को कॉफ़ी के पूरे उत्पादन और प्रसंस्करण इतिहास तक पहुंच देगा। अपनी कंपनी/सहकारी के लिए ट्रेसेबिलिटी के महत्त्व का वर्णन करें।",
      addLabel: "लेबल जोड़ें",
      chooseTitle: "शीर्षक चुनें",
      chooseLabelDesign: "लेबल डिजाइन टेम्प्लेट चुनें",
      uploadYourLogo: "अपना लोगो अपलोड करें",
      info5:
        "निर्देश: छवि का आकार कम से कम 1000 x 1000 पिक्सेल वर्ग होना चाहिए। आप पारदर्शी PNG का चयन कर सकते हैं ताकि बैकग्राउंड रंगों के साथ समंगत हो।",
      chooseTemplateColors: "टेम्प्लेट रंग चुनें",
      backgroundColor: "पृष्ठभूमि रंग",
      foregroundColor: "पूर्वभूमि रंग",
      labelStatus: "लेबल स्थिति",
      inactive: "निष्क्रिय",
      download: "डाउनलोड करें",
      enterLabelTitle: "लेबल शीर्षक दर्ज करें",
    },
    cacaoTraceability: {
      traceability: "ट्रेसेबिलिटी",
      cacaoTraceabilityMngmnt: "कैको ट्रेसेबिलिटी प्रबंधन",
      traceabilityPage: "ट्रेसेबिलिटी पेज",
      labelDesigner: "लेबल डिजाइनर",
      additionalInformation: "अतिरिक्त जानकारी",
      info1:
        "अपने उत्पाद के अतिरिक्त लोगों के बारे में जानकारी प्रदान करें। यह जानकारी कैको ट्रेसेबिलिटी पेज पर सार्वजनिक होगी।",
      addSlogan: "स्लोगन जोड़ें",
      additionalLogos: "अतिरिक्त लोगों",
      title: "शीर्षक",
      description: "विवरण",
      mapLink: "नक्शा लिंक",
      websiteLink: "वेबसाइट लिंक",
      addMedia: "मीडिया जोड़ें",
      uploadImageVideo: "छवि/वीडियो अपलोड करें",
      origin: "उत्पत्ति",
      info2:
        "अपने उत्पाद की उत्पत्ति देश के बारे में जानकारी प्रदान करें। यह जानकारी कैको ट्रेसेबिलिटी पेज पर सार्वजनिक होगी।",
      countryImage: "देश छवि",
      institutionalInfo: "संस्थागत जानकारी",
      info3:
        "अपनी कंपनी/सहकारी के बारे में जानकारी प्रदान करें, उपभोक्ताओं को आपके द्वारा किया गया संबंधित काम के बारे में बताएं। यह जानकारी कैको ट्रेसेबिलिटी पेज पर सार्वजनिक होगी।",
      cooperativeLogo: "सहकारी लोगो",
      traceabilityIntro: "ट्रेसेबिलिटी परिचय",
      info4:
        "यह खंड उपभोक्ता को कैको के पूरे उत्पादन और प्रसंस्करण इतिहास तक पहुंच देगा। अपनी कंपनी/सहकारी के लिए ट्रेसेबिलिटी के महत्त्व का वर्णन करें।",
      addLabel: "लेबल जोड़ें",
      chooseTitle: "शीर्षक चुनें",
      chooseLabelDesign: "लेबल डिजाइन टेम्प्लेट चुनें",
      uploadYourLogo: "अपना लोगो अपलोड करें",
      info5:
        "निर्देश: छवि का आकार कम से कम 1000 x 1000 पिक्सेल वर्ग होना चाहिए। आप पारदर्शी PNG का चयन कर सकते हैं ताकि बैकग्राउंड रंगों के साथ समंगत हो।",
      chooseTemplateColors: "टेम्प्लेट रंग चुनें",
      backgroundColor: "पृष्ठभूमि रंग",
      foregroundColor: "पूर्वभूमि रंग",
      labelStatus: "लेबल स्थिति",
      inactive: "निष्क्रिय",
      download: "डाउनलोड करें",
      enterLabelTitle: "लेबल शीर्षक दर्ज करें",
    },
    setting: {
      profileAuthSetting: "प्रोफ़ाइल प्रमाणीकरण सेटिंगस",
      logInOutSetting: "लॉग इन/लॉगऑफ़ सेटिंग्स",
      autoLogout: "अपने आप लॉग-ऑफ",
      unsuccessfulLoginAttempt: "लॉगिन का प्रयास असफल रहा ",
      unsuccessfulLoginLockPeriod: "असफल लॉगिन लॉक-आउट अवधि",
      passCriteriaSetup: "पासवर्ड मानदंड की रचना",
      passLength: "पासवर्ड की लंबाई",
      noUniquePassRequired: "आवश्यक अद्वितीय पासवर्ड की संख्या",
      maxPassAge: "पासवर्ड की अधिकतम उम्र",
      acceptableRangeOfChars: "वर्णों की स्वीकार्य श्रेणी",
      upperCase: "अप्पर केस",
      lowerCase: "लोअर केस ",
      numbers: "संख्या",
      specialChars: "विशेष वर्ण",
      uniqueSymbols: "अद्वितीय प्रतीक",
      loadingData: "डेटा लोड हो रहा है",
      currency: "मुद्रा",
      codeActivationTime: "कोड को सक्रिय करने का समय",
      changeGlobalSetting: "कोड को सक्रिय करने का समय",
      globalSetting: "समग्र सेटिंग्स",
      generalSetting: "सामान्य सेटिंग्स",
      hour: "घंटे",
      days: "दिन",
      minutes: "मिनट",
      perDay: "प्रति दिन",
      perHour: "प्रति घंटा",
      customised: "अनुकूलित",
    },
    coffeeData: {
      windBreaker: "हवा रोधक वृक्ष",
      horticultureInfo: "बागवानी वृक्ष",
      shadeTree: "छाया वृक्ष",
      coffeeVariety: "कॉफी की किस्में",
      coffeeSpecies: "कॉफी की प्रजाति",
      updateWindBreaker: "हवा रोधक वृक्षों के प्रकार को अपडेट करें",
      addWindBreaker: "एक नया मौसम प्रतिरोधी वृक्ष का प्रकार दर्ज करें",
      updateHorticultureInfo: "बागवानी वृक्षों के प्रकार को अपडेट करें",
      addHorticultureInfo: "बागवानी वृक्षों की नई प्रजाति दर्ज करें",
      updateShadeTree: "छायादार वृक्षों के  प्रकार को अपडेट करें",
      addShadeTree: "कॉफी की किस्म का प्रकार दर्ज करें",
      updateCoffeeVariety: "कॉफी की किस्म का प्रकार अपडेट करें",
      addCoffeeVariety: "कॉफी की किस्म का प्रकार दर्ज करें",
      deleteVarietyTitle: "किस्मों को हटाएँ ",
      deleteVarietyMessage: "क्या आप वाकई इस प्रजाति को हटाना चाहते हैं?",
      updateCoffeeSpecie: "कॉफी की प्रजाति अपडेट करें",
      deleteSpecieTitle: "प्रजाति हटाएँ",
      deleteSpecieMessage: "क्या आप वाकई इस प्रजाति को हटाना चाहते हैं?",
      addCoffeeSpecie: "कॉफ़ी की नई प्रजाति दर्ज करें",
      variety: "किस्में ",
      selectVariety: "किस्म का चयन करें",
      deleteCoffeeRecord: "क्या आप वाकई रिकॉर्ड हटाना चाहते हैं?",
      deleteCoffeeData: "कॉफी डेटा हटाएँ",
      topicRequired: "विषय का नाम आवश्यक है",
      coffeeAddSuccess: "कॉफी की प्रजाति सफलतापूर्वक जोड़ी गई।",
      treeTypeSuccess: "पेड़ का प्रकार सफलतापूर्वक दर्ज किया गया।",
      treeTypeUpdateSuccess: "पेड़ का प्रकार सफलतापूर्वक अपडेट किया गया।",
      coffeeVarietySuccess: "कॉफी की किस्म सफलतापूर्वक जोड़ी गई।",
      coffeeSpecieSuccess: "कॉफ़ी की प्रजाति सफलतापूर्वक अपडेट की गई ",
      nameRequired: "नाम आवश्यक है",
      notFound: "एडमिन का कोई कॉफ़ी डेटा नहीं मिला",
    },
    cacaoData: {
      cacao: "कैको",
      cacaoVariety: "कैको प्रकार",
      cacaoSpecies: "कैको प्रजाति",
      deleteCacaoData: "कैको डेटा हटाएं",
    },
    plantation: {
      farmerName: "किसान का नाम",
      phoneNumber: "फ़ोन नंबर",
      plantationName: "वृक्षारोपण का नाम",
      farm: "खेत",
      location: "स्थान",
      updatePlantationStatus: "वृक्षारोपण की स्थिति अपडेट करें",
      update: "अपडेट करें",
    },
    surveyBuilder: {
      addNewSurvey: "नया सर्वेक्षण जोड़ें",
      surveyTitle: "सर्वेक्षण शीर्षक",
      surveyName: "सर्वेक्षण नाम",
      surveyDescription: "सर्वेक्षण विवरण",
      describeSurvey: "सर्वेक्षण का विवरण दें",
      enableScheduling: "शेड्यूलिंग सक्षम करें",
      selectedDate: "चयनित तिथि",
      multiStepSurvey: "मल्टी-स्टेप सर्वेक्षण",
      multiStepSurveyDetails:
        "प्रश्नों की संख्या के आधार पर, सर्वेक्षण में सभी प्रश्नों को ग्रुप किया जाएगा और कदमों में प्रदर्शित किया जाएगा।",
      multiStep: "मल्टी-स्टेप",
      noQuestionEachStep: "प्रत्येक कदम में प्रश्नों की संख्या",
      surveyStatus: "सर्वेक्षण स्थिति",
      surveyStatusDetails:
        "सर्वेक्षण को केवल प्रश्न जोड़ने के बाद सक्षम किया जा सकता है। सर्वेक्षण को सक्षम करने से किसान स्वीकृति देने के लिए शुरू कर सकते हैं।",
      selectUsers: "उपयोगकर्ता चुनें",
      selectUsersDetails:
        "यदि चयनित उपयोगकर्ता अक्षम है, तो सर्वेक्षण सभी उपयोगकर्ताओं के लिए उपलब्ध होगा। यदि आप चयनित उपयोगकर्ताओं को सक्षम करते हैं, तो आप अगले कदम में एकाधिक उपयोगकर्ता का चयन कर सकते हैं।",
      linkWithFarms: "खेतों के साथ लिंक करें",
      linkWithFarmsDetails:
        "यदि सक्षम है, तो सर्वेक्षण को व्यक्तिगत खेतों के साथ लिंक किया जाएगा। यदि किसान के पास कई खेत हैं तो प्रत्येक खेत के पास अपना सर्वेक्षण होगा।",
      enabled: "सक्षम",
      disabled: "अक्षम",
      cancel: "रद्द करें",
      next: "आगे",
      surveySettings: "सर्वेक्षण सेटिंग्स",

      selectSurveyUsers: "सर्वेक्षण उपयोगकर्ताओं का चयन करें",
      selectToProceed: "कृपया आगे बढ़ने के लिए उपयोगकर्ता(ओं) का चयन करें",
      searchUsers: "उपयोगकर्ता खोजें",
      usersSelected: "चयनित उपयोगकर्ताएँ",
      conditional: "शर्तानुसार",
      autoConditional: "स्वच्छ शर्तानुसार",
      userName: "उपयोगकर्ता नाम",
      email: "ईमेल",
      membershipType: "सदस्यता प्रकार",
      membershipValidity: "सदस्यता मान्यता",
      membershipRemainingDays: "बचे हुए दिनों की संख्या",
      membershipRole: "सदस्य भूमिका",
      accountProgress: "खाते की प्रगति",
      status: "स्थिति",
      active: "सक्रिय",
      deactivated: "निष्क्रिय",
      continue: "जारी रखें",
      questions: "प्रश्न",
      responses: "प्रतिक्रियाएँ",
      deleteSurvey: "सर्वेक्षण हटाएं",
      editSurvey: "सर्वेक्षण संपादित करें",
      type: "प्रकार",
      compulsory: "अनिवार्य",
      createSurvey: "सर्वेक्षण बनाएं",
      surveyBuilder: "सर्वेक्षण निर्माता",
      surveyList: "सर्वेक्षण सूची",
      farm: "फार्म",
      responseDate: "प्रतिक्रिया दिनांक",
      viewSurvey: "सर्वेक्षण देखें",
      question: "प्रश्न",
      settings: "सेटिंग्स",
      addQuestion: "प्रश्न जोड़ें",
      surveysSubmitted: "सर्वेक्षण प्रस्तुत किए गए",
      surveyDetail: "सर्वेक्षण विवरण",
      conditionStatus: "शर्त स्थिति",
      conditionStatusDesc:
        "शर्तों के मेल मिलाने वाले उपयोगकर्ता स्वच्छ रूप से सर्वेक्षण के लिए पात्र होंगे।",

      endSurvey: "सर्वेक्षण समाप्त करें",
      publishSurvey: "सर्वेक्षण प्रकाशित करें",
      copy: "कॉपी करें",
      view: "देखें",
      startDate: "प्रारंभ तिथि",
      endDate: "समाप्ति तिथि",
      chooseDate: "तिथि चुनें",
      select: "चुनें",
      addSurveyQuestion: "सर्वेक्षण प्रश्न जोड़ें",
      editSurveyQuestion: "सर्वेक्षण प्रश्न संपादित करें",
      questionScore: "प्रश्न स्कोर",
      mandatory: "अनिवार्य",
      yes: "हाँ",
      no: "नहीं",
      options: "विकल्प",
      typeHere: "यहाँ टाइप करें",
      add: "जोड़ें",
      optionsHint:
        'उत्तर देने के लिए कृपया एंटर करें या "जोड़ें" पर क्लिक करें',
      surveyProgress: "सर्वेक्षण प्रगति में है",
      allResponses: "सभी प्रतिक्रियाओं का संक्षेप",
      responseQuestion: "प्रश्न अनुसार प्रतिक्रियाएँ",
      dateSubmitted: "प्रस्तुति की तिथि",
      answer: "उत्तर",
      totalScore: "कुल स्कोर",
      score: "स्कोर",
      singleSelection: "एकल चयन",
      multipleSelection: "एकाधिक चयन",
      if: "यदि",
      then: "तो",
      noResponse: "कोई प्रतिक्रिया नहीं",
      noSurveyFound: "कोई सर्वेक्षण नहीं मिला",
      createNewSurvey:
        'कृपया "सर्वेक्षण बनाएं" बटन का उपयोग करके सर्वेक्षण बनाएं',
      cannotPublish: "एक अक्षम सर्वेक्षण को प्रकाशित नहीं किया जा सकता!",
      deleteSurveyWarn:
        "क्या आप सुनिश्चित हैं कि आप सर्वेक्षण को हटाना चाहते हैं? यदि आप इसे हटाते हैं, तो सभी सर्वेक्षण प्रश्न और प्रस्तुतियाँ स्थायी रूप से हटा दी जाएगी।",
      noQuestionFound: "कोई प्रश्न नहीं मिला",
      createQuestion:
        'कृपया "प्रश्न जोड़ें" बटन का उपयोग करके पहले प्रश्न जोड़ें',
      deleteQuestion: "क्या आप सुनिश्चित हैं कि आप प्रश्न को हटाना चाहते हैं?",
      applyChanges: "आप इन परिवर्तनों को कैसे लागू करना चाहेंगे?",
      editFutureSurveys: "केवल आगामी सर्वेक्षण संपादित करें",
      editLiveSurveyOnly: "केवल लाइव सर्वेक्षण संपादित करें",
      surveyIsLive:
        "कृपया ध्यान दें कि सर्वेक्षण वर्तमान में लाइव है, और इस समय किसी प्रश्न को संपादित करने से पिछली प्रस्तुतियों पर प्रभाव पड़ सकता है। किसी समस्या से बचने के लिए, आप प्रश्नों में बदलाव करने के लिए सर्वेक्षण की प्रतिलिपि बनाने का विचार कर सकते हैं।",
      clickToCopy: "सर्वेक्षण प्रतिलिपि बनाने के लिए यहाँ क्लिक करें",
      applyChangesNow: "अब परिवर्तन लागू करें",
      copySurvey: "सर्वेक्षण प्रतिलिपि बनाएं",
      changeCopySurveyName:
        "आप प्रतिलिपि सर्वेक्षण संस्करण का नाम बदल सकते हैं।",
    },
    memberDataSection: {
      coffeeType: "कॉफी का प्रकार",
    },
    cropsReport: "फसल रिपोर्ट",
    today: "आज",
    week: "सप्ताह",
    month: "महीना",
    year: "साल",
    all: "सब",
    cropsStatistics: "फसल सांख्यिकी",
    crops: "फसलें",
    acres: "एकड़",
    totalPlantedArea: "कुल रोपित क्षेत्र",
    farmersChart: "किसान चार्ट",
    cropsName: "फसल का नाम",
    farmers: "किसान",
    farms: "किसानों का खेत",
    planted: "रोपा गया",
    plantedArea: "रोपित क्षेत्र",
    harvested: "कटा गया",
    yieldAcre: "फसल/एकड़",
    selectCrop: "फसल का चयन करें",
    listByYield: "फसल के आधार पर सूची",
    listByPlantedArea: "रोपित क्षेत्र के आधार पर सूची",
    equipmentReport: "उपकरण रिपोर्ट",
    equipmentChart: "उपकरण चार्ट",
    selectFarmer: "किसान का चयन करें",
    equipmentName: "उपकरण का नाम",
    region: "क्षेत्र",
    counts: "गिनती",
    large: "बड़ा",
    medium: "मध्यम",
    small: "छोटा",
    listByFarmer: "किसान के आधार पर सूची",
    rowsPerPage: "प्रति पृष्ठ पंक्तियाँ",
    farmersReport: "किसान रिपोर्ट",
    farmersStatistics: "किसान सांख्यिकी",
    averageFarmerLand: "औसत किसान भूमि",
    largeFarmers: "बड़े किसान",
    mediumFarmers: "मध्यम किसान",
    smallFarmers: "छोटे किसान",
    listByLand: "भूमि के आधार पर सूची",
    listByFarm: "खेत के आधार पर सूची",
    AvgLandAcre: "औसत भूमि/एकड़",
    listbyCrop: "फसल के आधार पर सूची",
    listbyZone: "क्षेत्र के आधार पर सूची",
    farmName: "खेत का नाम",
    zones: "क्षेत्र",
    area: "क्षेत्र",
    goalsAchievedReport: "लक्ष्य पूर्ण रिपोर्ट",
    listByCrops: "फसल के आधार पर सूची",
    goalsAchievedChart: "लक्ष्य पूर्ण चार्ट",
    goalsAchieved: "लक्ष्य पूर्ण",
    goalsFailed: "लक्ष्य असफल",
    successRate: "सफलता दर",
    achieved: "पूर्ण",
    equipment: "उपकरण",
    pests: "कीट",
    regions: "क्षेत्र",
    filterByCrops: "फसलों के द्वारा फ़िल्टर करें",
    searchCrops: "फसल खोजें",
    batchCode: "बैच कोड",
    batchRating: "बैच रेटिंग",
    MakeASelection: "चयन करें",
    typeTotalCoffeeQuantity: "कुल कॉफ़ी मात्रा टाइप करें",
    typeHumidity: "नमिता टाइप करें",
    valueInPercent: "प्रतिशत में मूल्य",
    purchaseOrderRequired: "क्रय आदेश आवश्यक है",
    totalCoffeeCherryRequired: "कुल कॉफ़ी चेरी आवश्यक है",
    processTypeRequired: "प्रक्रिया प्रकार आवश्यक है",
    stationInfo: "स्थान जानकारी",
    purchaseOrders: "क्रय आदेश",
    processingBatch: "प्रक्रिया बैच",
    processedCoffeeOutRequired: "प्रक्रियात्मक कॉफ़ी आउट आवश्यक है",
    lotNo: "लॉट नंबर",
    addNewS: "नया जोड़ें",
    viewAll: "सभी देखें",
    parchmentOut: "पार्चमेंट आउट",
    processingDone: "प्रक्रिया पूर्ण हुई",
    farmerLotID: "किसान और लॉट आईडी",
    weight: "वजन",
    plantationSettings: "बागवानी सेटिंग्स",
    PlantationsEachFarmerCanCreate: "प्रत्येक किसान की बागवानी बना सकती है",
    manageAdditionalPlantationRequests: "अतिरिक्त बागवानी अनुरोध प्रबंधित करें",
    autoApprove: "स्वचलित मंजूरी",
    adminApprovalRequired: "प्रशासक की मंजूरी आवश्यक है",
    close: "बंद करें",
    new_user: "नया उपयोगकर्ता",
    KGAcre: "किलोग्राम/एकड़",
  },
  farm:{
    farm: "खेत",
    farmName: "खेत का नाम",
    farmType: "खेत का प्रकार",
    farmSize: "खेत का आकार",
    farmLocation: "खेत का स्थान",
    farmOwner: "खेत का मालिक",
    activities: "क्रियाएँ",
    "search": "खोजें",
    "selectCountry": "देश का चयन करें",
    "filterByFarmName": "खेत के नाम द्वारा फ़िल्टर करें",
    "filterByCropType": "फसल प्रकार द्वारा फ़िल्टर करें",
    "filterByStartDate": "प्रारंभ तिथि द्वारा फ़िल्टर करें",
    "download": "डाउनलोड",
    "of": "का",
    "previousPage": "पिछला पृष्ठ",
    "nextPage": "अगला पृष्ठ",
    "view": "देखें",
    "activityDetails": "क्रिया विवरण",
    "activity": "क्रिया",
    "cropType": "फसल प्रकार",
    "startDate": "प्रारंभ तिथि",
    "endDate": "समाप्ति तिथि",
    "description": "विवरण",
    "close": "बंद करें",
    "farmActivities": "खेत की क्रियाएँ",  
    "listView": "सूची देखें",
    "calendarView": "कैलेंडर देखें",
    "scheduledActivities": "अनुसूचित क्रियाएँ",
    "completedActivities": "पूर्ण क्रियाएँ",
  },
  oma: {
    // land suitability
    landSuitibility: "भूमि उपयुक्तता",
    landSuitibilityReport: "भूमि उपयुक्तता रिपोर्ट",
    generateNewReport: "नई रिपोर्ट उत्पन्न करें",
    operatorName: "ऑपरेटर का नाम",
    issueDate: "मुद्दा तिथि",
    chooseYourLocation: "अपना स्थान चुनें",
    getLandEvaluation: "भूमि मूल्यांकन प्राप्त करें",
    downloadPdfReport: "पीडीएफ रिपोर्ट डाउनलोड करें",
    pleaseEnterCoordinateText:
      "कृपया कृषि भूमि के स्थान की गुणवत्ता देखने के लिए कोआर्डिनेट (देशांतर और अक्षांश) दर्ज करें।",
    noRecordAvailable: "कोई रिकॉर्ड उपलब्ध नहीं हैं।",
    overallScoreForLand: "भूमि उपयुक्तता के लिए समग्र स्कोर",
    landEvaluation: "भूमि मूल्यांकन",
    unsuitable: "अनुपयुक्त",
    marginally: "अल्पतय",
    suitable: "उपयुक्त",
    moderately: "मध्यम",
    highly: "अत्यधिक",
    back: "वापस",
    search: "खोज",
    showResults: "परिणाम दिखाएं",

    // weather analysis
    weatherAnalysisReport: "मौसम विश्लेषण रिपोर्टें",
    weatherAnalysis: "मौसम विश्लेषण",
    getWeatherAnalysis: "मौसम विश्लेषण प्राप्त करें",
    weatherReport: "मौसम की रिपोर्ट",
    filterByDate: "तारीख द्वारा फ़िल्टर करें",
    insertCoordinateText:
      "फार्म (या वृक्ष) स्थान के संदर्भ में ऊपर कोआर्डिनेट डालें, या नक्शा का उपयोग करके फार्म (या वृक्ष) स्थान का संकेत करें।",

    addTreeGeolocation: "वृक्ष भौगोलिक स्थान जोड़ें",
    editTreeGeolocation: "वृक्ष भौगोलिक स्थान संपादित करें",
    plantationDate: "लगाई गई तारीख",
    notes: "टिप्पणियाँ",
    uploadTreeImages: "वृक्ष छवियाँ अपलोड करें",

    valueAtTheCoordinatesOfInterest: "रुचि स्थानांक पर मूल्य",
    "Slope (%)": "ढाल (%)",
    "Soil texture (USDA class)": "मृदा की बनावट (USDA वर्ग)",
    "Coarse fragments (vol%)": "कठोर अंश (आयाम%)",
    Land: "भूमि",
    "Artificial surfaces (type)": "कृत्रिम पृष्ठ (प्रकार)",
    "Proximity to Type 1 and 2 Roads (meters)":
      "प्रकार 1 और 2 सड़कों के पास (मीटर)",
    "Soil Chemical Properties": "मृदा के रासायनिक गुण",
    "Soil Physical Properties": "मृदा के भौतिक गुण",
    "Soil organic carbon (%)": "मृदा कार्बनिक कार्बन (%)",
    "Soil pH": "मृदा pH",
    "Soil salinity (ECe))": "मृदा मृदाता (ECe)",
    "Mean annual temperature (°C)": "औसत वार्षिक तापमान (°C)",
    Weather: "मौसम",
    "Mean minimum temperature of coldest month (°C)":
      "सबसे ठंडे महीने का औसत न्यूनतम तापमान (°C)",
    "Mean annual precipitation (mm)": "औसत वार्षिक वर्षापात (mm)",
  },
  deforestation: {
    eudrComplianceStatus: "EUDR अनुपालन स्थिति",
    deforestationComplianceReport: "वनों की कटाई अनुपालन रिपोर्ट",
    noDeforestationComplianceReport:
      "कोई वनों की कटाई अनुपालन रिपोर्ट नहीं मिली",
    loadingDeforestationComplianceReport:
      "वनों की कटाई अनुपालन रिपोर्ट लोड हो रही है",
    farmName: "फार्म का नाम",
    farmRegistrationId: "फार्म पंजीकरण आईडी",
    farmerName: "किसान का नाम",
    farmerRegistrationId: "किसान पंजीकरण आईडी",
    uniqueFarmerId: "अद्वितीय किसान आईडी",
    uniqueFarmId: "अद्वितीय फार्म आईडी",
    farmLocation: "फार्म का स्थान",
    area: "क्षेत्र",
    farmAddress: "फार्म का पता",
    dateOfRequest: "अनुरोध की तिथि",
    status: "स्थिति",
    settings: "सेटिंग्स",

    farmLatitude: "फार्म अक्षांश",
    farmLongitude: "फार्म देशांतर",
    shareQRCode: "क्यूआर कोड साझा करें",
    copy: "कॉपी करें",

    allCountries: "सभी देश",
    allRegions: "सभी क्षेत्र",
    allFarms: "सभी फार्म",
    viewCertificate: "प्रमाणपत्र देखें",

    assignmentIssued: "असाइनमेंट जारी की गई",

    complianceCertification: "अनुपालन प्रमाणन",
    noComplianceCertification: "कोई अनुपालन प्रमाणन नहीं मिला",
    loadingComplianceCertification: "अनुपालन प्रमाणन लोड हो रहा है",

    eudrForestAssessment: "EUDR वन आकलन",
    assessmentReport: "मूल्यांकन रिपोर्ट",
    downloadPDF: "पीडीएफ डाउनलोड करें",
    back: "वापस",
    farmDetails: "फार्म विवरण",

    dimitraFarmId: "दिमित्रा फार्म आईडी",
    dimitraFermerId: "दिमित्रा किसान आईडी",

    totalGeofenceAreaHA: "कुल भू-फेंस क्षेत्र (हेक्टेयर)",
    forestLossHA: "वन हानि (हेक्टेयर)",
    forestGainHA: "वन लाभ (हेक्टेयर)",
    forestUnchangedHA: "वन अपरिवर्तित (हेक्टेयर)",
    shareCertificate: "प्रमाणपत्र साझा करें",
    forestUnchanged: "वन अपरिवर्तित",
    forestLoss: "वन हानि",
    forestGain: "वन लाभ",
    totalGeofenceArea: "कुल भू-फेंस क्षेत्र",
    print: "प्रिंट करें",
    deforestationProbability: "वनों की कटाई की संभावना",
    colorCode: "रंग कोड",
    geofenceArea: "भू-फेंस क्षेत्र",
    percentageOfGeofenceArea: "भू-फेंस क्षेत्र का प्रतिशत",
    view: "देखें",
    customization: "अनुकूलन",
    recordsPerpage: "प्रति पृष्ठ रिकॉर्ड्स",
    restoreDefault: "डिफ़ॉल्ट पुनर्स्थापित करें",
    apply: "लागू करें",
    forestAssessmentHelp:
      "यदि आपको इस रिपोर्ट के बारे में कोई प्रश्न हैं या इसे समझने में मदद चाहिए, तो कृपया हेल्प डेस्क के माध्यम से हमसे संपर्क करें।",
    overallDeforestationProbability: "कुल वनों की कटाई की संभावना",
    zeroOrNegligible: "शून्य/नगण्य",
    high: "उच्च",
    allStatus: "सभी स्थिति",
    low: "निम्न",
    veryHigh: "बहुत उच्च",
    medium: "मध्यम",
    veryLow: "बहुत निम्न",
    assessmentIssued: "मूल्यांकन जारी किया गया",
    certificateIssued: "प्रमाणपत्र जारी किया गया",
    assessmentNo: "मूल्यांकन संख्या",
    blockchainCertificateDesc:
      "प्रमाणपत्र की स्वीकृति पर ब्लॉकचेन प्रमाणपत्र मान्यता हैश उपलब्ध होगा",
    blockchainValidation: "ब्लॉकचेन प्रमाणपत्र मान्यता",
    openBlockchainPage: "ब्लॉकचेन पेज खोलें",
    clickLinkDesc:
      "ब्लॉकचेन पर प्रमाणपत्र को मान्य करने के लिए ऊपर दिए गए लिंक पर क्लिक करें",
    tooltip: {
      dimitraFarmId:
        "दिमित्रा प्रणाली में एक विशिष्ट फार्म से जुड़े अद्वितीय पहचानकर्ता।",
      farmName: "फार्म का निर्दिष्ट नाम।",
      farmRegistrationId: "फार्म का पंजीकरण संख्या।",
      farmLocation: "फार्म की विशिष्ट भौगोलिक समन्वय या स्थान।",
      dimitraFermerId:
        "दिमित्रा प्रणाली में एक व्यक्तिगत किसान से जुड़े विशिष्ट पहचानकर्ता।",
      farmerName: "फार्म के लिए जिम्मेदार व्यक्ति की पहचान।",
      farmerRegistrationId: "किसान का पंजीकरण संख्या।",
      assessmentNo: "मूल्यांकन को सौंपा गया अद्वितीय संख्या।",
    },
    red: "लाल",
    Yellow: "पीला",
    transparent: "पारदर्शी",
    darkRed: "गहरा लाल",
    brightRed: "उज्ज्वल लाल",
    orange: "नारंगी",
    lightBlue: "हल्का नीला",
    teal: "फ़िरोज़ा",
    zeroOrNegligibleProbability: "शून्य/नगण्य वनों की कटाई की संभावना",
    veryLowProbability: "बहुत निम्न वनों की कटाई की संभावना",
    lowProbability: "निम्न वनों की कटाई की संभावना",
    mediumProbability: "मध्यम वनों की कटाई की संभावना",
    highProbability: "उच्च वनों की कटाई की संभावना",
    veryHighProbability: "बहुत उच्च वनों की कटाई की संभावना",
    locationName: "स्थान का नाम",
    
    eudrDueDeligenceReports: "ईयूडीआर देय परिश्रम रिपोर्ट" ,
    EUDRAssessmentReport: "EUDR Assessment Report",
    createNewReport: "Create New Report",
    eudrRefNo: "ईयूडीआर संदर्भ नंबर.",
    eudrAndInternalRefNo: "ईयूडीआर आंतरिक संदर्भ नंबर.",
    internalRefNo: "आंतरिक संदर्भ नंबर.",
    supplier: "देने वाला",
    eoriNumber: "ईओआरआई नंबर",
    operator: "Operator",
    quantity: "Quantity",
    product: "उत्पाद",
    noOfFarms: "Number of Farms",
    farmsAndQuantity:"फार्म और मात्रा",
    country: "देश",
    lastUpdated: "अंतिम अद्यतन",
    dueDeligenceStatus: "उचित परिश्रम की स्थिति",
    edurDueDeligenceStatus: "ईयूडीआर उचित परिश्रम की स्थिति",
    reject: "अस्वीकार कर दिया गया है",
    pending: "लंबित है",
    approved: "स्वीकृत है"  ,
    completed: "पुरा चूका है" ,
    uploadedToEU:  "EU पोर्टल पर अपलोड किया गया",
    underReview:  "समीक्षा के अंतर्गत",
    compliant: "अनुपालक है",
    nonCompliant: "गैरअनुपालक है",
    analyzeDeforestation: "वनों की कटाई का विश्लेषण ",
    readyToProceed:  "आगे बढ़ने के लिए तैयार है",
    processingFarm: "फार्म प्रसंस्करण कर रहे हैं",
    mitigationRequired: "शमन आवश्यक",
    dueDiligence: "देय परिश्रम",
    
  },
  dueDiligence: {
    listOfFarmsInfo:"खेतों का एक व्यापक प्रदर्शन, जिसमें उत्पादन स्थान, उत्पादक का नाम, संचालन का देश, हेक्टेयर में भूमि क्षेत्र, कृषि गतिविधियों के प्रकार, वनों की कटाई से संबंधित आकलन और खेत संचालन से जुड़े संभावित जोखिमों के मूल्यांकन जैसी जानकारी शामिल है।",
    actions: "कार्रवाई",
    dueDiligenceReports: "देय परिश्रम रिपोर्ट",
    myFarms: "मेरे फार्म",
    dueDiligenceReportCreation: "देय परिश्रम रिपोर्ट निर्माण",
    dueDiligenceNew: "देय परिश्रम",
    createNewReport: "नई रिपोर्ट बनाएं",
    viewReport: "रिपोर्ट देखें",
  },
  of: "का",
  selectFarmers:"किसानों का चयन करें",
  noUploadToBlockchain: "ब्लॉकचेन पर अपलोड नहीं किया गया",
  noDataForBlockchain: "चूंकि उत्पादन स्थलों के लिए वनों की कटाई की कोई रिपोर्ट उत्पन्न नहीं की गई थी, इसलिए ब्लॉकचेन पर लिखने के लिए कोई डेटा नहीं था। यदि यह अप्रत्याशित था, तो कृपया सुनिश्चित करें कि पिछले चरणों में खेतों के लिए रिपोर्ट सही ढंग से उत्पन्न की गई थी।",
  pleaseAgreeToDeclaration: "कृपया निष्कर्ष निकालने के लिए घोषणा बयान से सहमत हों।",
  importProductionPlaceTT: "उपयोगकर्ताओं को फ़ाइल अपलोड या डाउनलोड विकल्पों का उपयोग करके उत्पादन स्थान डेटा आयात करने की अनुमति देता है।",
  defaultCircularGeofence: "जिन खेतों में जियोफेंस नहीं है या उनके आकार के बारे में जानकारी नहीं है, उन्हें 4 हेक्टेयर का डिफ़ॉल्ट सर्कुलर जियोफेंस सौंपा जाएगा। यदि औसत खेत का आकार 4 हेक्टेयर से छोटा है, तो कृपया नीचे दिए गए 'संपादित करें' बटन पर क्लिक करके डिफ़ॉल्ट आकार बदलें।",
  accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "EUDR के अनुसार, 4 हेक्टेयर से कम आकार के खेतों को बहुभुज की आवश्यकता नहीं है।",
  uploadOneDeforestationAssessmentForAllFarms: "सभी खेतों के लिए एक वनों की कटाई का आकलन अपलोड करें",
  uploadAssessment: "मूल्यांकन अपलोड करें",
};
